module.exports = "<a class=\"drop-menu-option-link\" (click)=\"navigate($event, 'app.authorized.reports.dp')\">Release Package Delivery</a>\n<a class=\"drop-menu-option-link\" (click)=\"navigate($event, 'app.authorized.reports.details')\">Audit</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/side-menu/reports-menu-drop-down/reports-menu-drop-down.component.html
// module id = 1838
// module chunks = 0